import { render, staticRenderFns } from "./SchoolDistrictEstimateDetail.vue?vue&type=template&id=48ad77c8&scoped=true&lang=pug"
import script from "./SchoolDistrictEstimateDetail.vue?vue&type=script&lang=ts"
export * from "./SchoolDistrictEstimateDetail.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "48ad77c8",
  null
  ,true
)

export default component.exports